import React, { useState } from 'react'

import { useParams } from 'react-router-dom'

import Faq from '../../../../../presentation/pages/common/faq'

import { useResource } from '../../../../../presentation/hooks/resource'
import { useFetchResources } from '../../../../../presentation/hooks/fetch-resources'

import { makeQuestions } from '../../../../usecases/questions/remote-questions-factory'

import IQuestion from '../../../../../presentation/interfaces/question'

const MakeFaq = () => {
  const [openFaq, setOpenFaq] = useState<number | null>(null)

  const [resource, resourceService] = useResource<IQuestion>(makeQuestions())

  const { type } = useParams<{ type: string }>()

  useFetchResources(resourceService.load, {
    type,
  })

  const handleToggle = (id: number) => {
    if (id === openFaq) {
      setOpenFaq(null)
    } else {
      setOpenFaq(id)
    }
  }

  document.title = `BuscarMédicos - FAQ - ${type}`

  const faqProps = {
    states: {
      openFaq,
      resource,
    },
    handlers: {
      handleToggle,
    },
  }

  return <Faq {...faqProps} />
}

export default MakeFaq
